import { ClientSide } from "~/@types";
import { IInsight } from "~/@types/generated/contentful";
import {
  InsightComponentData,
  useComponentData,
} from "~/contexts/ComponentDataProvider";
import { CircleIconCta, IconCta } from "../ctas";
import { Download } from "../icons";
import ChapterTakeover from "./ChapterTakeover";
import useIsMobile from "../utils/useIsMobile";

type InsightNavActionsProps = {
  insight: ClientSide<IInsight>;
  showChapters?: boolean;
  showDownload?: boolean;
};

export default function InsightNavActions({
  insight,
  showChapters = true,
  showDownload = true,
}: InsightNavActionsProps) {
  const { chapters } = useComponentData() as InsightComponentData;
  const hasChapters = chapters && Object.keys(chapters)?.length > 1;
  const isMobile = useIsMobile(1024);

  return (
    <div className="flex items-center gap-x-4">
      {showChapters && hasChapters && <ChapterTakeover marginBottom="mb-0" />}

      {showDownload && insight.fields.pdf?.fields?.file?.url && (
        <>
          {isMobile ? (
            <IconCta
              kind="black"
              icon={<Download />}
              label="Download"
              to={`https:${insight.fields.pdf.fields.file.url}`}
            />
          ) : (
            <CircleIconCta
              kind="white-hollow"
              icon={<Download />}
              label="Download"
              to={`https:${insight.fields.pdf.fields.file.url}`}
            />
          )}
        </>
      )}
    </div>
  );
}
